import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Landing from "./routes/Landing";

// Split by surface. A phone loading /play should not download the TV's podium,
// confetti and split-flap board, and /admin — which almost nobody opens —
// should be in neither. Landing stays eager because it is the first paint.
const loadHost = () => import("./routes/Host");
const loadPlay = () => import("./routes/Play");
const loadAdmin = () => import("./routes/Admin");

// React.lazy does not request a chunk until the component first renders, which
// puts the download *after* React boots — a serial round trip on the one path
// that matters most, a phone opening /play straight off a QR code. Kicking the
// import off here, while index.js is still being evaluated, overlaps it with
// React's own startup. The module registry dedupes, so React.lazy below picks
// up this same in-flight promise rather than issuing a second request.
const path = typeof window === "undefined" ? "" : window.location.pathname;
if (path.startsWith("/play")) void loadPlay();
else if (path.startsWith("/host")) void loadHost();
else if (path.startsWith("/admin")) void loadAdmin();

const Host = lazy(loadHost);
const Play = lazy(loadPlay);
const Admin = lazy(loadAdmin);

/**
 * Deliberately blank rather than a spinner: the chunk is already in flight
 * before this renders, and a spinner that appears and vanishes reads as jank.
 */
function ChunkFallback() {
  return <div className="min-h-dvh bg-stage" />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<ChunkFallback />}>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/host" element={<Host />} />
          <Route path="/play" element={<Play />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Landing />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
